"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LinkedInIcon = function LinkedInIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? _constants.colors.mediumGrey : _ref$color,
    height = _ref.height,
    width = _ref.width;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M1.925 6.798h3.29V16.96h-3.29V6.8zM14.2 6.7c2.336 0 4.172 1.462 4.172 4.61v5.65h-3.73v-5.258c0-1.377-.582-2.317-1.865-2.317-.98 0-1.527.634-1.78 1.246-.096.22-.08.526-.08.83v5.5H7.22s.048-9.315 0-10.162h3.694v1.595c.218-.698 1.4-1.693 3.283-1.693zM3.51 2c1.212 0 1.958.76 1.982 1.762 0 .984-.77 1.764-2.006 1.764h-.024c-1.19 0-1.962-.777-1.962-1.762C1.5 2.76 2.294 2 3.51 2z"
  }));
};
var _default = exports["default"] = LinkedInIcon;